module.exports = __webpack_public_path__ + "static/gallery08-ec1497b2a3bdd259b7aedbb0a20dcc69.jpg";